module.exports = __webpack_public_path__ + "img/nevazgny.720a17fb.png";